import { Box, Flex, Heading, Spacer, Text } from "@chakra-ui/react";
import { FooterInfo } from "../../layouts/Footer";
import { LandingHeader } from "../../layouts/Header";

export function Imprint() {

    return (
        <Flex flexDirection="column" height="100vh">
            <Box width="full" position="sticky" top="0" zIndex="sticky">
                <LandingHeader />
            </Box>

            {/* Scrollable Main Content */}
            <Box as="main" flex="1" p={5}>
                <Box width="80%" mx="auto">
                    <Heading as="h1" size="xl">
                        Impressum - Labchron
                    </Heading>

                    <Spacer my={5}/>

                    <Text fontWeight="bold">LabChron</Text>
                    <Text>Cedric Klimt</Text>
                    <Text>Johannes-Rebmann Straße 12</Text>
                    <Text>70839 Gerlingen</Text>
                    <Text>Deutschland</Text>

                    <Spacer my={5}/>

                    <Text fontWeight="bold">Kontakt</Text>
                    {/* <Text>Tel: 01234 56789</Text> */}
                    <Text>Email: contact@labchron.com</Text>
                    <Text>Verantwortlich für den Inhalt (gem. § 55 Abs. 2 RStV):</Text>
                    <Text>Cedric Klimt</Text>

                    <Spacer my={5}/>

                    <Text fontWeight="bold">Haftungsausschluss</Text>
                    <Text>Wir aktualisieren und ergänzen die Informationen auf ihrer Website nach bestem Wissen und Gewissen. Für die Aktualität, Richtigkeit und Vollständigkeit der Informationen übernehmen wir keine Gewähr und alle Informationen sind unverbindlich. Aufgrund der rechtlichen und technischen Umstände im Internet können wir keine Gewährleistung und Haftung für die Richtigkeit und Vollständigkeit des Inhalts der Werke sowie der eingestellten Informationen, deren maschinenlesbare Erfassung, deren elektronische Speicherung in Datenbanken, deren Verbreitung und die Einhaltung datenschutzrechtlicher und sonstiger Rechtspflichten durch Dritte übernehmen.</Text>

                    <Spacer my={5}/>

                    <Text fontWeight="bold">Externe Links</Text>
                    <Text>Verschiedene Gerichte haben entschieden, dass durch die Ausbringung von Links die Inhalte der verlinkten Seiten ggf. mitzuverantworten sind. Dies kann nur dadurch verhindert werden, dass man sich ausdrücklich von diesen Inhalten distanziert. Wir haben auf unseren Seiten Links zu anderen Seiten im Internet gelegt. Für alle diese Links gilt: Wir erklären, dass wir keinerlei Einfluss auf die Gestaltung und die Inhalte der gelinkten Seiten haben. Deshalb distanzieren wir uns hiermit ausdrücklich von allen Inhalten aller gelinkten Seiten auf unserer Homepage und machen uns diese Inhalte nicht zu eigen. Diese Erklärung gilt für alle auf unserer Homepage angezeigten Links.</Text>

                    <Spacer my={5}/>

                    <Text fontWeight="bold">Nutzungsbedingung</Text>
                    <Text>Alle Informationen, Texte, Bilder und Grafiken auf dieser Internetseite unterliegen dem Schutz des Urheberrechtes und anderer Schutzgesetze. Sie dürfen nur bei ausdrücklicher Genehmigung kopiert oder verbreitet werden.</Text>

                    <Spacer my={5}/>

                    <Text fontWeight="bold">Urherbrecht</Text>
                    <Text>Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht kommerziellen Gebrauch gestattet. Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.</Text>

                </Box>
            </Box>

            <FooterInfo />
        </Flex>
    );
}
